import React, { useState } from 'react'
import Header from '../../Component/Header'
import Menu from '../../Component/Menu'
import { Link, useNavigate } from 'react-router-dom'
import { Form, Formik } from 'formik'
import { FormikTextField } from '../../CommonComponents/FormField'
import Footer from '../../Component/Footer'
import withRouter from '../../withRouter'
import MasterService from '../MasterService'

const NewPrefix = () => {
  const naviagte = useNavigate()
    const [prefixtype,setPrefixType] = useState("")
    const [defaultprefix,setDefaultprefix] = useState("")

    const onSubmit = () =>{
      let data = {
        prefixtype:prefixtype,
        prefix:defaultprefix,
      }
      MasterService.AddPrefixType(data).then(()=>{
        naviagte(-1)
      })
    }
  return (
    <div>
    <Header />
    <Menu />
    <div className="content-wrapper">
      <div className="card">
        <ol className="breadcrumb float-sm-right">
          <li className="breadcrumb-item text-secondary">
            <Link to="/superadminmasters">Home</Link>
          </li>
          <li className="breadcrumb-item text-secondary">
            <Link to="/prefixtypes">Prefix Type</Link>
          </li>
          <li className="breadcrumb-item active">New Prefix Type</li>
        </ol>

        <div className="card-body">
          <Formik
            initialValues={{}}
            onSubmit={onSubmit}
                >
                {({ setFieldValue, values }) => (
                  <Form>
                     <div className="form-row">
                      <fieldset className='form-group col-md-3'>
                      <FormikTextField
                          className="form-control"
                          type="text"
                          name="prefixtype"
                          label="Prefix Type"
                          value={prefixtype}
                          onChange={(e) =>
                            setPrefixType(e.target.value)
                          }
                        />
                        </fieldset>
                        <fieldset className='form-group col-md-3'>
                      <FormikTextField
                          className="form-control"
                          type="text"
                          name="defaultprefix"
                          label="Default prefix"
                          value={defaultprefix}
                          onChange={(e) =>
                            setDefaultprefix(e.target.value)
                          }
                        />
                        </fieldset>
                        </div>
                        <fieldset className="form-group col-md-12">
                      <button
                                      className="btn btn-sm hovbuttonColour tw-mr-2"
                                      type="submit"
                                    >
                                      Save
                                    </button>
                                    <Link
                        as="button"
                        className="btn btn-sm deletebutton col-md-auto col-sm-12"
                        to={{ pathname: "/prefixtypes" }}
                      >
                        <b className="text-danger"> X </b>Cancel
                      </Link>
                                    </fieldset>
                        </Form>
                )}
                </Formik>
                </div>
                </div>
                </div>
                <Footer/>
    </div>
  )
}

export default withRouter(NewPrefix)